<template>
 <div id="app">
    <div class="ui sidebar inverted vertical menu">
      <span class="header item" style="text-align: center;">
        <a :href="smartAgricultureURL">
          <img id="menu_logo" class="logo" src="../assets/logo.png" />
        </a>
      </span>
      <div class="item">
        <h4 style="margin-bottom:0px;"><i class="user icon" style="float:left;margin-left:0px;margin-right:10px;"></i><span>{{ this.$store.state.user.user }}</span></h4>
        <h4 style="margin-top:0px;"><i class="icon" style="float:left;margin-left:0px;margin-right:10px;"></i></h4><span>{{ $t('components.navbar.usuarios_rol' + this.$store.state.user.role) }}</span>
      </div>
      <router-link v-if="isAdmin" class="item" to="/usersGroups">{{$t("components.navbar.UsersGroups")}}</router-link>
      <router-link v-if="isAdmin || isMantainer" class="item" to="/terminals">{{$t("components.navbar.Terminals")}}</router-link>
      <router-link v-if="isAdmin" class="item" to="/controlAccessCards">{{$t("components.navbar.Users")}}</router-link>
      <router-link class="item" to="/historicalaccesscontrol">{{$t("components.navbar.Historico_accesos")}}</router-link>
      <router-link v-if="isAdmin || isMantainer" class="item" to="/historicaloperation">{{$t("components.navbar.Historico_operaciones")}}</router-link>
      <router-link class="item" to="/about">{{$t("components.navbar.About")}}</router-link>
      <a class="item" :href="getUrlLogout()">{{ getTextoLogout() }}</a>
    </div>
    <div class="pusher">
      <div id="navbar" class="ui secondary menu" v-if="this.$route.path !== '/disconnected' && this.$route.path !== '/login' && !publicSection">
        <button class="ui item menu-button" @click="openMenu">
          <i class="bars icon"></i>
        </button>
      </div>
      <router-view :key="$route.fullPath"/>
    </div>
  </div>
</template>

<script>
import { Config } from '../config';
import VueConfig from '../../vue.config';

export default {

  name: 'navbar',
  props: ['publicSection'],
  data: function () {
    return {
      env: process.env.NODE_ENV,
      publicPath: VueConfig.publicPath,
      appParentName: Config.parentAppName,
      smartAgricultureURL: "",
    };
  },
  methods: {
    openMenu: function () {
      $('.ui.sidebar').sidebar('toggle');
    },
    logout: function () {
      this.$emit('logout');
    },
    getTextoLogout: function () {
      if (this.$store.state.user.isExternalLogin) {
        return this.$i18n.t('components.navbar.Volver') + this.appParentName;
      } else {
        return this.$i18n.t('components.navbar.Logout');
      }
    },
    getUrlLogout: function () {
      if (this.env === 'production') {
        if (this.$store.state.user.isExternalLogin) {
          return '/#main';
        } else {
          return this.publicPath + ((this.$store.state.user.language === 'es_ES')? '' : '?lang=' + this.$store.state.user.language);
        }
      } else {
        if (this.$store.state.user.isExternalLogin) {
          return 'http://localhost/#main';
        } else {
          return 'http://localhost' + this.publicPath;
        }
      }
    }
  },
  updated: function () {
    setTimeout(() => {
      $('.ui.sidebar').sidebar('hide');
      $('#navbar .ui.dropdown').dropdown();
    }, 100);
  },
  mounted: function () {

    this.smartAgricultureURL = window.location.origin;

    setTimeout(() => {
      $('.ui.sidebar').sidebar('hide');
      $('#navbar .ui.dropdown').dropdown();
    }, 100);
  },
  computed: {
    isAdmin: function () {
      return this.$store.state.user.role === 0;
    },
    isMantainer: function () {
      return this.$store.state.user.role === 1;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
